// frontend/src/services/cache/cacheService.js
/**
 * Simple in-memory cache service
 */
class CacheService {
  constructor() {
    this.cache = {};
    this.expirations = {};
  }

  /**
   * Get an item from cache
   * @param {string} key - The cache key
   * @returns {any} - The cached value or null if not found
   */
  get(key) {
    // Check if key exists and is not expired
    if (this.cache[key] && this.expirations[key] > Date.now()) {
      return this.cache[key];
    }
    
    // Remove expired entries
    if (this.cache[key]) {
      this.remove(key);
    }
    
    return null;
  }

  /**
   * Set an item in cache
   * @param {string} key - The cache key
   * @param {any} value - The value to cache
   * @param {number} ttl - Time to live in seconds (default: 300s)
   */
  set(key, value, ttl = 300) {
    this.cache[key] = value;
    this.expirations[key] = Date.now() + (ttl * 1000);
    
    return value;
  }

  /**
   * Remove an item from cache
   * @param {string} key - The cache key
   */
  remove(key) {
    delete this.cache[key];
    delete this.expirations[key];
  }

  /**
   * Clear all cache
   */
  clear() {
    this.cache = {};
    this.expirations = {};
  }

  /**
   * Remove expired items
   */
  cleanup() {
    const now = Date.now();
    
    Object.keys(this.expirations).forEach(key => {
      if (this.expirations[key] <= now) {
        this.remove(key);
      }
    });
  }
}

export default new CacheService();